// ===================================================== //
//                COMMON EVENT PROPERTIES
// ===================================================== //
export const CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES = {
  bipsDomain: 'deposit',
  schema: 'iglu:com.raisin/event_schema/jsonschema/1-0-3',
  portal: 'customer-portal',
  context: 'category-management-products',
  zone: 'Customer Portal',
  description: '',
  boundedContext: '',
} as const;

// Common properties shared among all events
export const COMMON_EVENT_PROPERTIES = {
  ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  context: 'category-management-banks',
  countryPlatform: typeof window !== 'undefined' ? window.location.hostname : '',
};

// Declare different components of CP.
export enum CUSTOMER_PORTAL_COMPONENT {
  OFFER_TABLE = 'Offer table',
  PRODUCT_CARDS = 'Product card',
  REFER_A_FRIEND = 'RaF link',
  MEDIA_TILE = 'Media tile',
  HERO = 'Hero',
  CLICKABLE_CARDS = 'Clickable cards',
  BANK_OFFERS_LIST = 'BankOffersList',
}

export enum BANK_EVENTS {
  OFFER_ROW_INTEREST_TAB_CLICKED = 'offer_row_interest_tab_clicked',
  OFFER_ROW_INVESTMENT_TAB_CLICKED = 'offer_row_investment_amount_tab_clicked',
  ORDER_CTA_CLICKED = 'order_cta_clicked',
  ALL_OFFERS_CTA_CLICKED = 'all_offers_cta_clicked',
  BANK_CARD_CLICKED = 'bank_card_clicked',
  LIST_OF_BANKS_SORTED = 'list_of_banks_sorted',
  TOP_OFFER_CLICKED = 'top_offer_clicked',
  PRODUCT_EXPANDED = 'product_expanded',
  ADDITIONAL_DETAILS_EXPANDED = 'bank_additional_details_expanded',
}

export enum BANK_PAGES {
  PRODUCT_PAGE = 'Bank product page',
  DETAIL_PAGE = 'Bank detail page',
}
